// extracted by mini-css-extract-plugin
module.exports = {"switch":"Toggle_switch__21RWm","slider":"Toggle_slider__3ibGH","round":"Toggle_round__3Xg6D"};